/**
 * Soren persist API — feed-state, done, remind, suppressions.
 */
import { apiFetch } from './client'

export interface SorenFeedState {
  suppressions: string[]
  snoozed: string[]
  done: string[]
}

export async function fetchSorenFeedState(): Promise<SorenFeedState> {
  const res = await apiFetch<{ data: SorenFeedState }>('GET', '/api/soren/feed-state')
  return (
    res.data ?? {
      suppressions: [],
      snoozed: [],
      done: [],
    }
  )
}

export async function markSorenCardDone(body: {
  kind: string
  project_id: number
  notification_ids?: number[]
  facts?: Record<string, unknown>
}): Promise<void> {
  await apiFetch('POST', '/api/soren/done', body)
}

export async function remindSorenCard(body: {
  kind: string
  project_id: number
  notification_ids?: number[]
  facts?: Record<string, unknown>
}): Promise<void> {
  await apiFetch('POST', '/api/soren/remind', body)
}

export async function skipFridayCheckIn(): Promise<void> {
  await apiFetch('POST', '/api/soren/checkins/skip', {})
}

export async function suppressSorenRule(body: {
  kind: string
  project_id: number
  facts?: Record<string, unknown>
}): Promise<void> {
  await apiFetch('POST', '/api/soren/suppressions', body)
}
